import ReactGA from 'react-ga4';
import { getEnv, isProduction, isDevelopment } from './env';

let isInitialized = false;

export function initAnalytics(): void {
  const measurementId = getEnv('VITE_GA_MEASUREMENT_ID');

  if (!measurementId) {
    if (isDevelopment()) {
      console.log('[Analytics] GA Measurement ID not set - analytics disabled');
    }
    return;
  }

  try {
    ReactGA.initialize(measurementId, {
      testMode: !isProduction(),
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    });
    isInitialized = true;
  } catch (error) {
    console.error('[Analytics] Failed to initialize:', error);
  }
}

export function trackPageView(path: string, title?: string): void {
  if (!isInitialized) return;
  try {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title || document.title,
    });
  } catch (error) {
    console.error('[Analytics] Failed to track pageview:', error);
  }
}

function trackEvent(category: string, action: string, label?: string): void {
  if (!isInitialized) return;
  try {
    ReactGA.event({ category, action, label });
  } catch (error) {
    console.error('[Analytics] Failed to track event:', error);
  }
}

export function trackSignup(method: string = 'email'): void {
  trackEvent('User', 'Signup', method);
}

export function trackLogin(method: string = 'email'): void {
  trackEvent('User', 'Login', method);
}

export function setAnalyticsUser(userId: string): void {
  if (!isInitialized) return;
  try {
    ReactGA.set({ userId });
  } catch (error) {
    console.error('[Analytics] Failed to set user ID:', error);
  }
}

export function clearAnalyticsUser(): void {
  if (!isInitialized) return;
  try {
    ReactGA.set({ userId: null });
  } catch (error) {
    console.error('[Analytics] Failed to clear user ID:', error);
  }
}
